import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import PaymentStatusCard from './PaymentStatusCard';

interface Friend {
  id: string;
  email: string;
  status: 'pending' | 'paid';
}

interface FriendsListProps {
  friends: Friend[];
  onRemoveFriend: (id: string) => void;
  onSendReminder: (id: string) => void;
}

const FriendsList: React.FC<FriendsListProps> = ({ friends, onRemoveFriend, onSendReminder }) => {
  if (friends.length === 0) {
    return (
      <div className="text-center py-12 bg-gray-50 rounded-xl">
        <p className="text-gray-500">No friends added yet. Invite someone to split the cost!</p>
      </div>
    );
  }

  return (
    <div className="space-y-4">
      <h2 className="text-xl font-semibold text-gray-900 mb-4">Invited Friends</h2>
      <AnimatePresence>
        {friends.map((friend) => (
          <motion.div
            key={friend.id}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, x: -100 }}
            transition={{ duration: 0.2 }}
          >
            <PaymentStatusCard
              friend={friend}
              onRemove={() => onRemoveFriend(friend.id)}
              onSendReminder={() => onSendReminder(friend.id)}
            />
          </motion.div>
        ))}
      </AnimatePresence>
    </div>
  );
};

export default FriendsList;